import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Steps } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';

import ModalCustomersList from './CustomersList';
import ModalVehiclesList from './VehiclesList';
import { CustomerVehicleReduced } from '@/core/domain/people/CustomerVehicles/CustomerVehicles.types';

interface Props {
  visible: boolean;
  handleVisible: VoidFunction;
  onVehicleSelected: (selectedVehicle: CustomerVehicleReduced) => void;
}

const VehicleSearchModal = ({
  visible,
  handleVisible,
  onVehicleSelected,
}: Props) => {
  const [current, setCurrent] = useState(0);
  const [selectedCustomerId, setSelectedCustomerId] = useState<number>();
  const intl = useIntl();

  const handleOnCancel = () => {
    setCurrent(0);
    setSelectedCustomerId(undefined);
    handleVisible();
  };

  const handleSelectCustomerId = (customerId?: number) => {
    setCurrent(current + 1);
    setSelectedCustomerId(customerId);
  };

  const handleSelectVehicle = (vehicle: CustomerVehicleReduced) => {
    handleOnCancel();
    onVehicleSelected(vehicle);
  };

  const steps = [
    {
      title: intl.formatMessage({
        id: 'diagnostics.modal.steps.selectCustomer',
      }),
      content: (
        <ModalCustomersList
          visible={visible}
          onSelectCustomerId={handleSelectCustomerId}
        />
      ),
    },
    {
      title: intl.formatMessage({
        id: 'diagnostics.modal.steps.selectVehicle',
      }),
      content: (
        <ModalVehiclesList
          customerId={selectedCustomerId}
          onSelectVehicle={handleSelectVehicle}
        />
      ),
    },
  ];

  const modalFooter = (
    <div>
      {current > 0 && (
        <Button
          type="ghost"
          onClick={() => {
            setCurrent(0);
            setSelectedCustomerId(undefined);
          }}
        >
          <FormattedMessage id="diagnostics.modal.steps.selectCustomer" />
        </Button>
      )}
      <Button onClick={() => handleOnCancel()}>
        <FormattedMessage id="commons.modal.button.cancel" />
      </Button>
    </div>
  );

  return (
    <Modal
      title={intl.formatMessage({ id: 'diagnostics.modal.title' })}
      visible={visible}
      onCancel={handleOnCancel}
      width={1200}
      footer={modalFooter}
    >
      <Steps current={current}>
        {steps.map((step) => (
          <Steps.Step key={step.title} title={step.title} />
        ))}
      </Steps>
      <div style={{ marginTop: '24px' }}>{steps[current].content}</div>
    </Modal>
  );
};

VehicleSearchModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  handleVisible: PropTypes.func.isRequired,
  onVehicleSelected: PropTypes.func.isRequired,
};

export default VehicleSearchModal;
